module.exports = __webpack_public_path__ + "img/sport-utility-vehicle.adca1bbb.png";